import * as React from "react";
import { useTranslation } from "react-i18next";
import { FormikFormGroup } from "components/common";
const CloudEmailFormGroup = () => {
  const { t } = useTranslation("enterprise_authentication");
  return /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      label: t("cloud_email_form_group.label"),
      name: "email",
      maxLength: 254,
      type: "email",
      required: true,
      help: t("cloud_email_form_group.help")
    }
  );
};
export default CloudEmailFormGroup;
